import { Panel } from "@/components/admin/ui";

const inputClass = "mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm dark:border-white/15 dark:bg-white/5 dark:text-white";
const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500";

export const BusinessProfileSection = ({ form, legalName, onChange }) => {
  const descLength = form.description?.length || 0;
  return (
    <Panel title="Business Profile" subtitle="How your organization appears across Nova Opsis." testId="org-settings-business-profile">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <label className={labelClass}>Business Name</label>
          <input
            value={form.name}
            onChange={(e) => onChange({ name: e.target.value })}
            data-testid="org-settings-name-input"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>Legal Name</label>
          <input
            value={legalName || ""}
            disabled
            placeholder="Not set"
            data-testid="org-settings-legal-name-input"
            className={`${inputClass} cursor-not-allowed opacity-70`}
          />
          <p className="mt-1 text-xs text-slate-400 dark:text-slate-500">Managed by Nova Opsis. Contact your Nova Opsis representative to update.</p>
        </div>
        <div>
          <label className={labelClass}>Business Phone</label>
          <input
            value={form.business_phone}
            onChange={(e) => onChange({ business_phone: e.target.value })}
            data-testid="org-settings-phone-input"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>Business Email</label>
          <input
            type="email"
            value={form.business_email}
            onChange={(e) => onChange({ business_email: e.target.value })}
            data-testid="org-settings-email-input"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>Website</label>
          <input
            value={form.website}
            onChange={(e) => onChange({ website: e.target.value })}
            placeholder="https://"
            data-testid="org-settings-website-input"
            className={inputClass}
          />
        </div>
        <div>
          <label className={labelClass}>Business EIN</label>
          <input
            value={form.business_ein}
            onChange={(e) => onChange({ business_ein: e.target.value })}
            placeholder="XX-XXXXXXX"
            data-testid="org-settings-ein-input"
            className={inputClass}
          />
        </div>
        <div className="sm:col-span-2">
          <div className="flex items-center justify-between">
            <label className={labelClass}>Short Description</label>
            <span data-testid="org-settings-description-counter" className="text-xs font-semibold text-slate-400 dark:text-slate-500">{descLength}/250</span>
          </div>
          <textarea
            value={form.description}
            onChange={(e) => onChange({ description: e.target.value.slice(0, 250) })}
            maxLength={250}
            rows={3}
            placeholder="A short summary of what your business does."
            data-testid="org-settings-description-input"
            className={inputClass}
          />
        </div>
      </div>
    </Panel>
  );
};
